/**
 * Case-insensitive access to query parameters.
 *
 * `URLSearchParams.get` matches the key exactly, so a link carrying `usertype` instead of `userType`
 * reads as absent. That alone would be a visible failure, but the session fallbacks in App.tsx then
 * substitute a previously stored value — so the same link works or fails depending on what the tab
 * visited earlier, rather than on the link itself.
 *
 * Links into the configurator are frequently generated by external systems, so key casing is not
 * something we control. Reading them case-insensitively removes the whole class of problem.
 */
export const caseInsensitiveParams = (search: string) => {
  const normalised = new URLSearchParams();

  new URLSearchParams(search).forEach((value, key) => normalised.append(key.toLowerCase(), value));

  return {
    get: (name: string): string | null => normalised.get(name.toLowerCase()),
  };
};
